import { ReactNode } from "react";
import useStyles from "./MainBanner.styles";
import { useMediaQuery } from "@mui/material";
import theme from "@/assets/theme";

type MainBannerProps = {
  bannerUrl: string;
  bannerText?: ReactNode;
  bannerContent?: ReactNode;
  smBanner?: boolean;
  video: string;
  api: ReactNode;
};

export default function MainBanner({
  bannerUrl,
  bannerText,
  bannerContent,
  smBanner,
  video,
  api,
}: MainBannerProps) {
  smBanner = smBanner ?? false;

  const isBiggermMd = useMediaQuery(theme.breakpoints.up("md"));
  const { classes } = useStyles({
    params: {
      bannerUrl: bannerUrl,
      smBanner: smBanner && isBiggermMd,
      locale: "",
    },
  });

  return (
    <>
      {api === "VIDEO" ? (
        <>
          <div className={classes.bannerContainer}>
            <video
              autoPlay
              playsInline
              loop
              muted
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            >
              <source src={video} type="video/mp4" />
            </video>
          </div>
        </>
      ) : (
        <>
          <div className={classes.bannerContainer}>
            <div className={classes.textContainer}>
              {bannerText ? (
                <div className={classes.bannerText}>{bannerText}</div>
              ) : (
                <></>
              )}
              {bannerContent ? (
                <div className={classes.bannerContent}>{bannerContent}</div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
